import { useState, useEffect, useRef, useCallback, Fragment, useMemo } from "react";
import style from "./SelRewildingMode.module.scss";
import { v4 } from "uuid";
import IconButton from '@mui/material/IconButton';
import * as YStyled from '../../../Styleds';
import AppConfig from '../../../AppConfig';
const SelRewildingMode = ({ initSelectIndex=0,onSelect}) => {
    const [currentModeIndex, set_currentModeIndex] = useState(initSelectIndex);
    
    useEffect(()=>{
        if(onSelect)
            onSelect(AppConfig.modeEnum[currentModeIndex]);
    },[currentModeIndex]);
    return (
        <div className={style.app}>
            <div className={style.mode}>
                <YStyled.Span size={17} style={{paddingBottom:"1.4rem"}}>{AppConfig.modeEnum[currentModeIndex].label}</YStyled.Span>
                <div>
                    <IconButton onClick={e => {
                        set_currentModeIndex(props => {
                            props--;
                            if (props < 0)
                                props = AppConfig.modeEnum.length - 1;
                            return props;
                        })
                    }} >
                        <img src="./assets/ui/arrowLeft.png" />
                    </IconButton>
                    <img src={AppConfig.modeEnum[currentModeIndex].img} />
                    <IconButton onClick={e => {
                        set_currentModeIndex(props => {
                            props++;
                            if (props >= AppConfig.modeEnum.length)
                                props = 0;
                            return props;
                        })
                    }}>
                        <img src="./assets/ui/arrowRight.png" />
                    </IconButton>
                </div>

                <div className={style.dots}>
                    {AppConfig.modeEnum.map((v, k) => (
                        <div key={k} className={k === currentModeIndex ? ` ${style.selected}` : style.dot} >
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default SelRewildingMode;